/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ContentBannerModel,
  HeaderModel,
  NewsContentModel,
  NewsModel,
  RankingSeriesModel,
  SeriesMatomeModel,
  SiteSettingModel,
  SiteToppageResponseModel,
  TopItemModel,
  TopPopupModel,
} from '../models/index';
import {
    ContentBannerModelFromJSON,
    ContentBannerModelToJSON,
    HeaderModelFromJSON,
    HeaderModelToJSON,
    NewsContentModelFromJSON,
    NewsContentModelToJSON,
    NewsModelFromJSON,
    NewsModelToJSON,
    RankingSeriesModelFromJSON,
    RankingSeriesModelToJSON,
    SeriesMatomeModelFromJSON,
    SeriesMatomeModelToJSON,
    SiteSettingModelFromJSON,
    SiteSettingModelToJSON,
    SiteToppageResponseModelFromJSON,
    SiteToppageResponseModelToJSON,
    TopItemModelFromJSON,
    TopItemModelToJSON,
    TopPopupModelFromJSON,
    TopPopupModelToJSON,
} from '../models/index';

export interface GetNewsRequest {
    page?: number;
    size?: number;
    newsCategory?: GetNewsNewsCategoryEnum;
}

export interface GetNewsByNewsIdRequest {
    newsId: string;
    xComiciUserToken?: string;
}

export interface GetPopupRequest {
    xComiciUserToken?: string;
}

export interface GetSeriesRankingRequest {
    rankingCategory?: GetSeriesRankingRankingCategoryEnum;
    isTopPage?: boolean;
}

export interface GetSeriesSpecialByUrlRequest {
    url: string;
    isMobile?: boolean;
    page?: number;
    specialSize?: number;
    seriesSpecialSort?: GetSeriesSpecialByUrlSeriesSpecialSortEnum;
    xComiciUserToken?: string;
}

/**
 * 
 */
export class SiteApi extends runtime.BaseAPI {

    /**
     * ニュース一覧を取得します。
     * 新着情報リスト取得
     */
    async getNewsRaw(requestParameters: GetNewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NewsModel>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.newsCategory !== undefined) {
            queryParameters['newsCategory'] = requestParameters.newsCategory;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/news`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NewsModelFromJSON(jsonValue));
    }

    /**
     * ニュース一覧を取得します。
     * 新着情報リスト取得
     */
    async getNews(requestParameters: GetNewsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NewsModel> {
        const response = await this.getNewsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ニュースIDをもとに、特定のニュースを取得します。
     * 新着情報1件取得
     */
    async getNewsByNewsIdRaw(requestParameters: GetNewsByNewsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NewsContentModel>> {
        if (requestParameters.newsId === null || requestParameters.newsId === undefined) {
            throw new runtime.RequiredError('newsId','Required parameter requestParameters.newsId was null or undefined when calling getNewsByNewsId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserToken !== undefined && requestParameters.xComiciUserToken !== null) {
            headerParameters['X-Comici-User-Token'] = String(requestParameters.xComiciUserToken);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/news/{news_id}`.replace(`{${"news_id"}}`, encodeURIComponent(String(requestParameters.newsId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NewsContentModelFromJSON(jsonValue));
    }

    /**
     * ニュースIDをもとに、特定のニュースを取得します。
     * 新着情報1件取得
     */
    async getNewsByNewsId(requestParameters: GetNewsByNewsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NewsContentModel> {
        const response = await this.getNewsByNewsIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 配信されているポップアップの一覧を取得します。
     * ポップアップ取得
     */
    async getPopupRaw(requestParameters: GetPopupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TopPopupModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserToken !== undefined && requestParameters.xComiciUserToken !== null) {
            headerParameters['X-Comici-User-Token'] = String(requestParameters.xComiciUserToken);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/popups`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TopPopupModelFromJSON(jsonValue));
    }

    /**
     * 配信されているポップアップの一覧を取得します。
     * ポップアップ取得
     */
    async getPopup(requestParameters: GetPopupRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TopPopupModel> {
        const response = await this.getPopupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 配信されている作品のランキングを取得します。
     * ランキング取得
     */
    async getSeriesRankingRaw(requestParameters: GetSeriesRankingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RankingSeriesModel>>> {
        const queryParameters: any = {};

        if (requestParameters.rankingCategory !== undefined) {
            queryParameters['rankingCategory'] = requestParameters.rankingCategory;
        }

        if (requestParameters.isTopPage !== undefined) {
            queryParameters['isTopPage'] = requestParameters.isTopPage;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/ranking`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RankingSeriesModelFromJSON));
    }

    /**
     * 配信されている作品のランキングを取得します。
     * ランキング取得
     */
    async getSeriesRanking(requestParameters: GetSeriesRankingRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RankingSeriesModel>> {
        const response = await this.getSeriesRankingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 特定の特集ページの内容を取得します。
     * 作品まとめページ取得
     */
    async getSeriesSpecialByUrlRaw(requestParameters: GetSeriesSpecialByUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SeriesMatomeModel>> {
        if (requestParameters.url === null || requestParameters.url === undefined) {
            throw new runtime.RequiredError('url','Required parameter requestParameters.url was null or undefined when calling getSeriesSpecialByUrl.');
        }

        const queryParameters: any = {};

        if (requestParameters.isMobile !== undefined) {
            queryParameters['isMobile'] = requestParameters.isMobile;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.specialSize !== undefined) {
            queryParameters['specialSize'] = requestParameters.specialSize;
        }

        if (requestParameters.seriesSpecialSort !== undefined) {
            queryParameters['seriesSpecialSort'] = requestParameters.seriesSpecialSort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserToken !== undefined && requestParameters.xComiciUserToken !== null) {
            headerParameters['X-Comici-User-Token'] = String(requestParameters.xComiciUserToken);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/special/{url}`.replace(`{${"url"}}`, encodeURIComponent(String(requestParameters.url))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SeriesMatomeModelFromJSON(jsonValue));
    }

    /**
     * 特定の特集ページの内容を取得します。
     * 作品まとめページ取得
     */
    async getSeriesSpecialByUrl(requestParameters: GetSeriesSpecialByUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SeriesMatomeModel> {
        const response = await this.getSeriesSpecialByUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * サイト設定を取得します
     * サイト設定を取得する
     */
    async getSiteInfoRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SiteSettingModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/sites/settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SiteSettingModelFromJSON(jsonValue));
    }

    /**
     * サイト設定を取得します
     * サイト設定を取得する
     */
    async getSiteInfo(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SiteSettingModel> {
        const response = await this.getSiteInfoRaw(initOverrides);
        return await response.value();
    }

    /**
     * 配信されているTopページのバナーの一覧を取得します。  取得される一覧はTopページのバナーのみを含みます。
     * 外部リンクバナー取得
     */
    async getTopBannersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ContentBannerModel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/sites/banners`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ContentBannerModelFromJSON));
    }

    /**
     * 配信されているTopページのバナーの一覧を取得します。  取得される一覧はTopページのバナーのみを含みます。
     * 外部リンクバナー取得
     */
    async getTopBanners(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ContentBannerModel>> {
        const response = await this.getTopBannersRaw(initOverrides);
        return await response.value();
    }

    /**
     * 配信されているTopページでヘッダの項目の一覧を取得します。
     * ヘッダ取得
     */
    async getTopHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<HeaderModel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/sites/headerItems`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HeaderModelFromJSON));
    }

    /**
     * 配信されているTopページでヘッダの項目の一覧を取得します。
     * ヘッダ取得
     */
    async getTopHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<HeaderModel>> {
        const response = await this.getTopHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * トップページの特集枠内容を取得します。
     * 特集枠取得
     */
    async getTopItemsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TopItemModel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/features`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TopItemModelFromJSON));
    }

    /**
     * トップページの特集枠内容を取得します。
     * 特集枠取得
     */
    async getTopItems(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TopItemModel>> {
        const response = await this.getTopItemsRaw(initOverrides);
        return await response.value();
    }

    /**
     * 配信されているTopページのスライダーバナーの一覧を取得します。  取得される一覧はTopページのスライダーバナーのみを含みます。
     * カルーセル取得
     */
    async getTopSlideBannersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ContentBannerModel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/carousels`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ContentBannerModelFromJSON));
    }

    /**
     * 配信されているTopページのスライダーバナーの一覧を取得します。  取得される一覧はTopページのスライダーバナーのみを含みます。
     * カルーセル取得
     */
    async getTopSlideBanners(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ContentBannerModel>> {
        const response = await this.getTopSlideBannersRaw(initOverrides);
        return await response.value();
    }

    /**
     * 雑誌ダッシュボードの メイン機能 > TOP構成 ページで設定するトップページに表示する項目と表示順設定を取得します 表示する項目のみを返却します
     * トップページ表示項目取得
     */
    async getToppageSectionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SiteToppageResponseModel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/sites/toppage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SiteToppageResponseModelFromJSON));
    }

    /**
     * 雑誌ダッシュボードの メイン機能 > TOP構成 ページで設定するトップページに表示する項目と表示順設定を取得します 表示する項目のみを返却します
     * トップページ表示項目取得
     */
    async getToppageSections(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SiteToppageResponseModel>> {
        const response = await this.getToppageSectionsRaw(initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetNewsNewsCategoryEnum = {
    1: 'お知らせ',
    2: '新刊',
    3: '注目',
    4: 'イベント',
    5: '告知',
    6: 'メディア掲載'
} as const;
export type GetNewsNewsCategoryEnum = typeof GetNewsNewsCategoryEnum[keyof typeof GetNewsNewsCategoryEnum];
/**
 * @export
 */
export const GetSeriesRankingRankingCategoryEnum = {
    Manga: 'manga',
    Gravure: 'gravure'
} as const;
export type GetSeriesRankingRankingCategoryEnum = typeof GetSeriesRankingRankingCategoryEnum[keyof typeof GetSeriesRankingRankingCategoryEnum];
/**
 * @export
 */
export const GetSeriesSpecialByUrlSeriesSpecialSortEnum = {
    1: '人気順',
    2: '新作順'
} as const;
export type GetSeriesSpecialByUrlSeriesSpecialSortEnum = typeof GetSeriesSpecialByUrlSeriesSpecialSortEnum[keyof typeof GetSeriesSpecialByUrlSeriesSpecialSortEnum];
